import { memo, useMemo, useCallback, useEffect, useState, createRef } from 'react';
import { View, StyleSheet } from 'react-native';
import {
  I18n,
  Utils,
  Container,
  FormFooter,
  Navigation,
  Select,
  FormInput,
} from '../../components';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { REQUESTING, SUCCESS } from '../../../actions/statusTypes';
import { resetStatus } from '../../employer/actions';

export default memo(
  connect(
    function (state, ownProps) {
      const regions = state.entities.metaData.vaRegions.map((r) => ({
        label: r.name,
        value: r.id,
      }));
      return {
        saveMedRecruiterClinicalLocationsStatus:
          state.screens.employer.saveMedRecruiterClinicalLocationsStatus,
        errorMessage: state.screens.employer.errorMessage,
        regions: regions,
      };
    },
    function (dispatch) {
      return {
        actions: bindActionCreators({ resetStatus }, dispatch),
      };
    }
  )(function (props) {
    const propVaRegion = props.item?.va_region || props.selectedRegion;
    const vaRegionName = props.regions.find((r) => r.value == propVaRegion).label;
    const [selectedVARegion, setVARegions] = useState(propVaRegion || null);
    const [selectedVARegionName, setVARegionName] = useState(vaRegionName || null);
    const [selectedLocation, setLocation] = useState(props.item?.name || null);

    useEffect(
      function () {
        if (props.saveMedRecruiterClinicalLocationsStatus === SUCCESS) {
          Navigation.dismissAllModals();
        }
      },
      [props.saveMedRecruiterClinicalLocationsStatus]
    );
    useEffect(function () {
      return function () {
        props.actions.resetStatus();
      };
    }, []);

    function handleCancel() {
      Navigation.dismissAllModals();
    }

    function handleSave() {
      props.onSave({
        vaRegion: selectedVARegion,
        vaLocation: selectedLocation,
        clinical_location_id: props.item?.clinical_location_id,
      });
    }

    function handleVARegionSelected(vaRegions) {
      setVARegions(vaRegions.value);
      setVARegionName(props.regions.find((r) => r.value === vaRegions.value).label);
    }

    function handleLocationSelected(location) {
      setLocation(location);
    }

    const footer = (
      <FormFooter
        onCancel={handleCancel}
        onSave={handleSave}
        saveDisabled={!(selectedVARegion && selectedLocation)}
        cancelLabel="Cancel"
        saveLabel={props.saveLabel || 'Save'}
      />
    );

    return (
      <Container
        scrollView={false}
        style={THEME.container}
        stickyFooter={footer}
        renderActivityOverlay={props.saveMedRecruiterClinicalLocationsStatus === REQUESTING}
        errorMessage={props.errorMessage?.message}
      >
        <View style={[{ paddingHorizontal: 35, paddingVertical: 15, zIndex: 1000 }]}>
          <Select
            required={true}
            closeOnSelect={true}
            options={props.regions}
            label="VA Region"
            value={{ label: selectedVARegionName, id: selectedVARegion }}
            onValue={handleVARegionSelected}
            webMode={true}
            containerStyle={{ width: 200 }}
            editable={!props.item}
          />
          <FormInput
            value={selectedLocation}
            label={'Location Name'}
            required={true}
            onChangeText={handleLocationSelected}
          />
        </View>
      </Container>
    );
  })
);

const styles = StyleSheet.create({
  container: {
    ...THEME.container,
    alignItems: 'center',
    paddingBottom: 40,
  },
  inputContainer: {
    width: '100%',
    maxWidth: 400,
    flex: 1,
    borderWidth: 1.5,
    borderRadius: 10,
    borderColor: 'rgb(170,170,170)',
    backgroundColor: COLOR.contrast,
    padding: 10,
    paddingHorizontal: 15,
  },
  input: {
    ...THEME.input,
    ...FONT.regular,
    fontSize: __WEB__ ? 12 : 12,
  },
});
